import React from 'react';
import { SocialProofPopup, FloatingCTA } from './components/Shared';
import { HeroSection, ProblemSection, OpportunitySection, SystemSection, ContentDemoSection, BenefitsSection, TestimonialsSection, BonusesSection, OfferSection, GuaranteeSection, FAQSection, ClosingSection } from './components/Sections';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-inter selection:bg-yellow-300 selection:text-slate-900" data-id="element-0">
      {/* Top Banner */}
      <div className="bg-slate-900 text-white text-center py-2 px-4 text-sm font-medium font-inter tracking-wide" data-id="element-1">
        ⚠️ ATENCIÓN PADRES: Oferta especial por tiempo limitado
      </div>

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <OpportunitySection data-id="element-5" />
        <SystemSection data-id="element-6" />
        <ContentDemoSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <ClosingSection data-id="element-14" />
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-8 text-center font-inter text-sm pb-24 sm:pb-8" data-id="element-15">
        <div className="max-w-4xl mx-auto px-4" data-id="element-16">
          <p className="mb-4" data-id="element-17">
            © {new Date().getFullYear()} Sistema NeuroAvance Para Niños™.
            Todos los derechos reservados.
          </p>
          <p className="text-xs opacity-60" data-id="element-18">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Conversion Elements */}
      <SocialProofPopup data-id="element-19" />
      <FloatingCTA data-id="element-20" />
    </div>;
}